import type { FC } from "react";
import type { FilterChip } from "@motain/xpa-proto-files-web/lib/types/chips";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import { LargeToggleButton } from "@/components/large-toggle-button/LargeToggleButton";
import { isNullable } from "@/types/isNullable";
import { isNonNullable } from "@/types/isNonNullable";
import classnames from "classnames";
import { LargeToggleButtonLink } from "@/components/large-toggle-button/LargeToggleButtonLink";

const CHIP_ICON_DEFAULT_SIZE = 24;

type FilterChipProps = FilterChip & { className?: string };

export const Chip: FC<FilterChipProps> = (props) => {
  const { link, image, selected, className } = props;

  if (isNullable(link)) {
    return <></>;
  }

  return selected ? (
    <LargeToggleButton
      className={classnames("title-8-bold", className)}
      aria-label={link.nameA11y}
      isActive={selected}
    >
      {isNonNullable(image) && (
        <ImageWithFallback
          src={image.path}
          alt={image.alt}
          darkModeSrc={image.darkModePath}
          width={image.size?.width ?? CHIP_ICON_DEFAULT_SIZE}
          height={image.size?.height ?? CHIP_ICON_DEFAULT_SIZE}
          isPreloaded={image.isPreloaded}
        />
      )}
      {link.name}
    </LargeToggleButton>
  ) : (
    <LargeToggleButtonLink
      href={link.urlPath}
      onClick={() => {
        if (isNonNullable(link.trackingEvents)) {
          trackingService.sendXpaTracking(
            link.trackingEvents,
            EventType.EVENT_CLICK,
          );
        }
      }}
      aria-label={link.nameA11y}
      className={classnames("title-8-medium", className)}
    >
      {isNonNullable(image) && (
        <ImageWithFallback
          src={image.path}
          alt={image.alt}
          darkModeSrc={image.darkModePath}
          width={image.size?.width ?? CHIP_ICON_DEFAULT_SIZE}
          height={image.size?.height ?? CHIP_ICON_DEFAULT_SIZE}
          isPreloaded={image.isPreloaded}
        />
      )}
      {link.name}
    </LargeToggleButtonLink>
  );
};
